export default __webpack_public_path__ + "static/digipay-top-notch-application-security-4660f0cd3a1684ce66098f4e31e8e5e9.png";